<template>
  <div class="shared-hotel-app-restore">
      <!-- bg="linear-gradient(118deg, #FF981F 0%, #F9591B 100%)" -->
    <nav-bar titleText="共享饭店" fontColor="#fff" @goBack="goBack" @clickCondition="clickCondition" @goDeatilSearch="goDeatilSearch" :height="navHeight" :whiteBack="issearch?false:true" :issearch="issearch" :issearchs="issearchs" :boxShadow="issearch?'0px 2px 4px 0px rgba(0, 0, 0, 0.03)':'0px 0px 0px 0px'" :bg="issearch?'#fff':'linear-gradient(118deg, #FF981F 0%, #F9591B 100%)'">
      <template v-slot:default>
        <div class="nav-bar-right">
          <!-- <img src="../../assets/shared-hotel/break.png" :class="{'turn': turn}">
          <p>刷新定位</p> -->
          <div class="card-box" @click="goCardHomg">卡包</div>
        </div>
      </template>
    </nav-bar>
    <div class="empty" v-show="emptyShow"></div>
    <div class="top-search-div">
        <input v-model="searchvalue" placeholder="请输入店铺名称" @focus="goDeatilSearch" :style="client==11?'width: calc(100% - 14px);':''"/>
        <div class="search-icon"><img src="../../assets/shared-hotel/search.png" /></div>
        <div :class="client==11?'search-btns':'search-btn'">搜索</div>
    </div>
    <div class="swipe">
      <van-swipe class="home-swipe" :autoplay="3000">
        <van-swipe-item v-for="(item, index) in bannerList" :key="index">
            <img :src="item.img_url" @click="imgClick(item)" />
        </van-swipe-item>
      </van-swipe>
    </div>
<!-- :style="topBarStyle" -->
    <div class="topBar" >
      <div class="list-top">
        <div class="left">适用门店</div>
        <div class="right" @click="breakEvent('1')">
          <img src="../../assets/shared-hotel/newBreak.png" :class="{'turn': turn}">
          <p>刷新定位</p>
        </div>
      </div>
      <div class="condition">
        <div
          v-for="(item, i) in selectedList"
          :key="i"
          class="tag"
          :class="{'tag-active': item.selected}"
          @click="clickCondition(item)"
        >{{ item.text }}</div>
      </div>
    </div>

    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :offset="50">
        <div class="empty-placehoder"></div>
        <div class="list-box" v-for="(item, i) in list" :key="i">
          <div class="list-box-warpper">
          <div class="list-box-left">
            <img :src="item.logo" alt="">
          </div>
          <div class="list-box-right">
            <div class="content">
              <div class="left" @click="toStoreInfo(item)">
                <div class="title">
                  <span class="t-left">{{item.shop_name}}</span>
                  <span class="t-right" v-if="item.distance">{{`${((item.distance)/1000).toFixed(2)}km`}}</span>
                </div>
                <div class="addres">{{item.address}}{{item.house_number}}</div>
              </div>
              <div class="right" @click="getMap(item)">
                <img src="../../assets/shared-hotel/position1.png" alt="">
              </div>
            </div>
            <span class="left-amount">剩余可充值额度：{{item.quota_data && parseFloat(item.quota_data.actual_rechargeable_amount).toFixed(2)}}</span>
            <p><span class="right-amount">未核销额度：{{item.quota_data &&parseFloat(item.quota_data.recharged_amount-item.quota_data.consumed_amount) > 0 ? item.quota_data && parseFloat(item.quota_data.recharged_amount-item.quota_data.consumed_amount).toFixed(2):0.00}}</span></p>
            <div class="discounts" :style="item.isfold?'':'height:20px;overflow: hidden;'"  v-if="item.recharge_promotion.length>0">
              <div class="discount" v-for="(item1, i) in item.recharge_promotion" :key="i">充{{item1.recharge_amount}}送{{item1.present_amount}}</div>
              <!-- <div class="discount" v-for="(item, i) in [1]" :key="i">充1000送1000</div> -->
              <img v-if="item.isshowfold" class="foldimg" :src="item.isfold?foldtop:foldbottom" alt="" @click="item.isfold=!item.isfold"/>
            </div>
          </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
    <div class="back_top" @click="backTop" v-if="issearch">
        <img src="../../assets/shared-hotel/backtop.png" alt=""/>
        <div class="backtop_text">顶部</div>
    </div>
    <!-- <div class="imgPopup" v-show="showImg">
      <img class="left" :src="popupImage" alt="">
      <img class="right" src="../../assets/shared-hotel/close.png" alt="" @click="showImg = false"> 
      <div class="close" @click="showImg = false"></div>
    </div> -->
  </div>
</template>

<script>
import navBar from './components/navBar'
import dsbridge from 'dsbridge'
import { mapState, mapMutations } from "vuex";
export default {
  name:"store",
  data() {
    return {
      foldbottom:require("@/assets/shared-hotel/fold_bottom.png"),
      foldtop:require("@/assets/shared-hotel/fold_top.png"),
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      page: 0,
      pageSize:10,
      latitude:'',  // 经度
      longitude:'',  // 纬度
      distance:0,
      storeId:'',
      selectedList: [
        {text: '距离最近', selected: true},
        {text: '充值最优惠', selected: false},
        {text: '可充值额度最高', selected: false},
      ],
      turn: false,
      client: 0,
      isToast: false,
      images:[],
      emptyShow: true,
      navHeight: '60px',
      topBarStyleIsFixed: false,
      bannerList: [],
      timer10: 0,
      fn: null,
      showImg: false,
      popupImage: '',
      // TODO: 测试大图
      test_img: require('../../assets/shared-hotel/testh5.jpg'),
      searchvalue:'',
      issearch:false,
      isopacity:0,
      issearchs:false,
      isIOS:false,
      iswhite:false,
    }
  },
 created() {
    if (this.$route.query.token) {
      this.$api.setToken(this.$route.query.token);
    }
    this.$api.get('im/member/talker/white').then(res=>{//判断是否白名单，是否显示返回按钮
        this.iswhite=res.white;
    });
    // let u = navigator.userAgent;
    // this.isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    this.latitude = this.$route.query.lat
    this.longitude = this.$route.query.long
    this.getOffshopUserInfo();
    this.deductionUA()
    localStorage.setItem('longitude', this.$route.query.long)
    localStorage.setItem('latitude', this.$route.query.lat)
    this.getBanner()
  },
  mounted() {
    window.setLocation = this.setLocation 
    this.setPullRefreshStyle()
    this.breakEvent('0')
    document.addEventListener("scroll", this.scrollHander, true); // 监听页面滚动事件
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
    }),
    topBarStyle(){
      return this.topBarStyleIsFixed ? {position: 'fixed'} : {}
    },
    vanPullRefreshStyle(){
      return this.topBarStyleIsFixed ? {'padding-top': '84px'} : {}
    },
  },
  destroyed() {
    const appDom = document.querySelector('body')
    appDom.removeEventListener('scroll', this.scrollHander, false)
  },
  components:{
    navBar
  },
  methods: {
      //页面滚动监听方法
    scrollHander() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 0) {
        this.emptyShow = false
        this.navHeight = '44px'
      }
      if (scrollTop > 60) {
          this.issearch=true;
      }else if (scrollTop <= 60) {
          this.issearch=false;
      }
      if(scrollTop > 110){
         this.issearchs=true; 
          this.navHeight = '95px'
      }else if(scrollTop <= 110){
        this.issearchs=false; 
        this.navHeight = '44px'
      }
      if (scrollTop == 0) {
        this.emptyShow = true
        this.navHeight = '60px'
      }
    },
      ...mapMutations(["setState"]),
    //昵称和id
    getOffshopUserInfo(){
        this.$api.post('/offshop/member/getUserInfo',{token:this.$route.query.token}).then((res)=>{
            this.userInfo.nickname = res.nickname;
            this.userInfo.user_id = res.user_id;
        });
    },
      //前往店铺详情搜索界面
    goDeatilSearch() {
      this.$router.push({
        path: "/sharedHotel/storeSearch",
        query: {
          long: this.longitude,
          lat:this.latitude
        },
      });
    },
    backTop(){
        document.documentElement.scrollTop=0
    },
    imgClick(banner){
      const token = localStorage.getItem('_token')
      if ( [1, 2, 3].includes(banner.advertising_type) && ! token) {
        throw new Error('未能获取到token')
      }

      // 1  商品广告  2 店铺广告  3 原生页面广告  4 H5广告  5 展示型广告（不发生跳转）
      switch (parseInt(banner.advertising_type)) {
        case 1:
        case 2:
            if (banner.href) {
            window.location.href = `${banner.href}&lng=${this.longitude}&lat=${this.latitude}&token=${token}`
            return
          }
        case 3:
          // this.$router.push(`${banner.href}?token=Bearer%20${token}`)
          if (banner.href.startsWith('http')) {
            window.location.href = `${banner.href}?token=${token}`
            return
          }
          if (banner.href.startsWith('xblife')) {
            const param = {
              routePath: `${banner.href}`
            }
            this.params(JSON.stringify(param), JSON.stringify(param), 'toOriginal')
          }
          break;

        case 4:
          let href = banner.href
          if (! /http.*:\/\/.+\?.+=.+/.test(href)) {
            href = `${href}?token=${token}`
          } else {
            href = `${href}&token=${token}`
          }
          window.location.href = href
          // this.$router.push(`${banner.href})
          // banner.href = 'https://ss2.bdstatic.com/70cFvnSh_Q1YnxGkpoWK1HF6hhy/it/u=1730713693,2130926401&fm=26&gp=0.jpg'
          // this.$router.push({
          //   path: '/sharedHotel/adv',
          //   query: {
          //     href: banner.href,
          //     advertising_name: banner.advertising_name,
          //     // token: token,
          //   },
          // })
          break;
          
        case 5:
          // this.popupImage = banner.href
          // this.showImg = true

      }
    },
    setPullRefreshStyle(){
      // const dom = document.querySelector('.van-pull-refresh')
      // const shouldHeight = document.body.clientHeight - dom.getBoundingClientRect().top
      // dom.style.height = shouldHeight + 'px'
    },
    goCardHomg(){
      this.$router.push('/sharedHotel/cardHome')
    },
    getBanner(){
      const param = {
        labels: [
          'shallBuy_cardBag_index_banner'
        ]
      }
      this.$api.post('/adspace/index/get/ad/list', param)
      .then(data => {
        this.bannerList = [...data.shallBuy_cardBag_index_banner]
        this.images = this.bannerList.map(item => {
          return item.img_url
        })
        
        // 测试长图
        // this.bannerList.forEach(item => {
        //   item.advertising_type = 6
        //   item.large_img_url = this.test_img
        // });
        // 测试动图
        // this.bannerList.push({img_url: require('./test11.gif')})
      })
      .catch(err => {
        console.log(err)
        err.message && this.$toast(err.message)
      })
    },
    getLocation(num) {
      this.params(JSON.stringify({ is_initiative : num,show_text : '我们需要获取您的地理位置权限，向您展示附近共享饭店信息及获取位置导航' }), JSON.stringify({ is_initiative : num,show_text : '我们需要获取您的地理位置权限，向您展示附近共享饭店信息及获取位置导航' }), "getLocation")
    },
    setLocation(location) {
      const _v = JSON.parse(location)
      this.longitude = _v.longitude
      this.latitude = _v.latitude
      this.page = 0
      this.list = []
      this.onLoad()
      
      if (this.isToast) {
        this.$toast('刷新成功')
      }
      this.isToast = true
      clearTimeout(this.timer)
      setTimeout(() => {
        this.turn = false 
      }, 200); 
    },
    goBack() {
        if(this.$route.query.from == 'h5'){
            if(this.iswhite){//判断是否白名，为true则跳转线下首页
                window.location.href=process.env.VUE_APP_CLIENT_URL+"/o2o/home?token="+localStorage.getItem('_token')
            }else{//为false则返回原生的线下首页
                this.params(1,1,'goHome');
            }
        }else {
            this.$router.go(-1)//立即买单跳转过来时的返回
            // this.params('', '', 'goBack')//原生金刚区进入时调用的返回
        }
    },
    // breakImg() {
    //   this.turn = true
    // },
    deductionUA() {
      let ua = navigator.userAgent.toLowerCase();
      if (/iphone|ipad|ipod|macintosh/i.test(ua)) {
        this.client = 11
      } else if (/android/.test(ua)) {
        this.client = 10
      }
    },
    breakEvent(num) { 
      this.turn = true
      this.timer = setTimeout(() => {
        if (this.isToast) {
          this.$toast('刷新失败')
        }
        this.turn = false
      },3000)
        if (this.client === 10) {
            this.getLocation(num)
            return
        }
        if (this.client === 11) {
            dsbridge.call("getLocation", this.setLocation)
        }
    },
    clickCondition(item){
      item.selected = ! item.selected
    //   this.refreshing = true
    //   this.onRefresh()
        this.page = 0;
        this.getStoreList()
    },
    getMap(item) {
      let param = {
        lon: item.longitude,
        lat: item.latitude,
        address:item.address,
      }
      this.params(JSON.stringify(param),JSON.stringify(param),'getMap')
    },
    onLoad() { 
      if (this.latitude && this.longitude) {
      // if (true) {
        this.getStoreList()
        return
      }
      // 开始进来需要等待获取到经纬度之后才去 getStoreList
      let count = 0
      this.timer10 = setInterval(() => {
        if (this.latitude && this.longitude) {
          clearInterval(this.timer10)
          this.getStoreList();
        }

        count ++
        // 最多重试5次
        if (count >= 5) {
          this.loading = false;
          this.refreshing = false;
          this.finished = true
          this.turn = false
          return
        }

      }, 1000)
      
    },
    onRefresh() {
      this.page = 0;
      // 清空列表数据
      this.finished = false;
       // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
    getStoreList() {
      this.page ++
      let params = {
        lng: this.longitude,
        lat: this.latitude,
        page:this.page,
        pageSize:this.pageSize,
        distance: this.selectedList[0].selected ? 1 : 0,
        discount: this.selectedList[1].selected ? 1 : 0,
        quota: this.selectedList[2].selected ? 1 : 0,
      }
  
      this.$api.post("/offshop/member/canteen/membership-card/applicability", params)
      .then((data) => {
          //控制折叠
        data.list.map((item)=>{
            let str=0;
            for(let i=0;i<item.recharge_promotion.length;i++){
                str+=item.recharge_promotion[i].recharge_amount.toString().length+item.recharge_promotion[i].present_amount.toString().length+2
            }
            if(str>=22){
                item.isshowfold=true;//超出24个字就先显示折叠的图标
                item.isfold=false;
            }
        })
        let _list = data.list
        if (this.refreshing||this.page==1) {
          this.list = [];
          this.finished = false;
        }

        this.list.push(..._list)

        if (this.list.length === 0 || _list.length === 0) {
          this.finished = true;
          this.loading = false;
          this.refreshing = false;
          return;
        }
        this.loading = false;

        if (data.current_page == data.last_page) {// 数据全部加载完成
          this.finished = true;
        }
        if (this.refreshing) {
          this.$toast("刷新成功");
          this.refreshing = false;
        }

        if (! this.finished && ! this.loading && this.list.length <= 3) {
          this.onLoad()
        }
        this.turn = false
      })
      .catch(()=>{
        this.loading = false;
        this.refreshing = false;
        this.finished = true
        this.turn = false
      })
     },
    toStoreInfo(item) {
      let param = {
        lon: item.longitude,
        lat: item.latitude,
        id: item.id,
      }
      this.$router.push({
        path: "/sharedHotel/storeDetail",
        query: {
            id: item.id,
            lng: item.longitude,
            lat: item.latitude,
        },
      });
    //   this.params(JSON.stringify(param),JSON.stringify(param),'toStoreInfo')
    },
  }
};
</script>

<style lang="less">
html,body{
    overflow-x: inherit;//取消外层滚动，内层不设置高度，解决keepAlive不生效
    overflow-y: inherit;//取消外层滚动，内层不设置高度，解决keepAlive不生效
}
.shared-hotel-app-restore {
  padding-top: 104px;
  width: 100%;
  position: relative;
//   height: 100%;
  box-sizing: border-box;
//   overflow-y: auto;
  background-color: #f5f6f7;
  .nav-bar-right {
    position: absolute;
    right: 0;
    margin: 0 16px;
    top: 52px;
    height: 29px;
    line-height: 29px;
    display: flex;
    align-items: center;
    justify-content: center;
    .card-box {
      width: 50px;
      height: 25px;
      background: rgba(255, 255, 255, 0.15);
      border-radius: 13px;
      border: 1px solid rgba(255, 255, 255, 0.5);
      text-align: center;
      font-size: 15px;
      font-weight: 600;
      color: #FFFFFF;
      line-height: 25px;
    }
  }
  .back_top{
    width: 50px;
    height: 50px;
    background: #FFFFFF;
    box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.11);
    border: 1px solid #EDEDED;
    border-radius: 50%;
    text-align: center;
    position: fixed;
    right: 5%;
    bottom:15%;
    img{
       width: 21px;
       height: 11px;
       margin-top: 10px;
    }
    .backtop_text{
        font-weight: 600;
        color: #999999;
        font-size:12px;
    }
  }
.top-search-div {
  display: block;
  margin: 0 auto;
  width: calc(100% - 30px);
  padding-top: 6px;
  padding-bottom: 6px;
  box-sizing: border-box;
  position: relative;
  margin-bottom:8px;
  input::-webkit-input-placeholder{
    color: #999999;
}
  input {
    -webkit-appearance: none;//input去掉自带的内阴影
    height: 30px;
    width: calc(100% - 5px);
    border-radius: 20px;
    outline: none;
    // border: none;
    text-indent: 38px;
    font-size: 14px;
    border:1px solid #F9591B;
  }
  .search-icon{
    width: 16px;
    height: 16px;
    display: inline-block;
    position: absolute;
    top: 50%;
    left: 14px;
    transform: translateY(-50%);
    img {
      width: 100%;
      height: 100%;
    }
  }
  .search-btn{
    display: inline-block;
    width: 60px;
    height: 32px;
    background: linear-gradient(118deg, #FF981F 0%, #F9591B 100%);
    border-radius: 18px;
    font-weight: 400;
    color: #FFFFFF;
    font-size: 15px;
    text-align: center;
    line-height: 32px;
    position: absolute;
    top:7px;
    right: 0px;
  }
  .search-btns{
      display: inline-block;
    width: 65px;
    height: 37px;
    background: linear-gradient(118deg, #FF981F 0%, #F9591B 100%);
    border-radius: 20px;
    font-weight: 400;
    color: #FFFFFF;
    font-size: 15px;
    text-align: center;
    line-height: 37px;
    position: absolute;
    top:7px;
    right: -2px;
  }
  
}
  .shared-hotel-app-content {
    // width: 100%;
    // background: #F5F6F7;
  }

  .empty {
    background-color: #f5f6f7;
    width: 100%;
    height: 16px;
    border-radius: 18px 18px 0 0;
    position: absolute;
    top: 92px;
    left: 0;
    z-index: 999;
  }

  .swipe {
    margin: 0 12px;
    background: #F5F6F7;
    border-radius: 18px 18px 0px 0px;
    .home-swipe {
      border-radius: 4px 4px 4px 4px;
      // -webkit-transform:rotate(0deg);  // IOS和部分安卓 border-radius在transform时失效，解决方法：在其父元素设置 -webkit-transform:rotate(0deg);
      .van-swipe__track {
        // border-radius: 4px 4px 4px 4px; 
        // -webkit-transform:rotate(0deg); 
      }
      .van-swipe-item {
        height: 115px !important;
      }
      img {
        width: 100%;
        // height: 115px;
        background-size:cover;
        border-radius: 4px 4px 4px 4px;
      }
    }
  }
  .topBar {
    // top: 88px;
    left: 0;
    z-index: 1;
    width: 100%;
    background-color: #f5f6f7;
  }
  .list-top {
    display: flex;
    padding: 15px 12px 12px;
    justify-content: space-between;
    text-align: center;
    background-color: #f5f6f7;
    .left {
      height: 25px;
      font-size: 18px;
      font-weight: 600;
      color: #333333;
      line-height: 25px;
    }
    .right {
      display: flex;
      position: relative;
      top: 5px;
      left: 0;
      img {
        width: 14px;
        height: 13px;
        margin-right: 3px;
        position: absolute;
        top: 2px;
        left: -15px;
      }
      p {
        height: 18px;
        font-size: 13px;
        color: #F9591B;
        line-height: 18px;
      }
    }
  }
  .condition {
    padding: 0 12px 2px;
    display: flex;
    width: 100%;
    box-sizing: border-box;
    // position: fixed;
    // top: 88px;
    // left: 0;
    background: #f5f6f7;
    z-index: 99;
    .tag {
      font-size: 14px;
      color: #666666;
      width: 26.667%;
      line-height: 20px;
      background: #fff;
      border-radius: 3px;
      padding-top: 5px;
      padding-bottom: 5px;
      margin-right: 6px;
      text-align: center;
      &.tag-active {
        background: rgba(249, 89, 27, 0.1);
        color: #F9591B;
      }
      &:nth-of-type(3) {
        width: 42.067%;
      }
    }
  }

  .van-list {
    background-color: #F5F5F5;
    // padding-top: 49px;
  }
  .empty-placehoder {
    padding-bottom: 1px;
    background-color: #F5F5F5;
  }

  .list-box {
    padding: 12px;
    margin: 10px 12px 0;
    display: flex;
    // border-bottom: 1px solid #f1f1f1;
    background-color: #fff;
    border-radius: 6px;

    .list-box-warpper {
      width: 100%;
      display: flex;
      // background-color: #fff;
      border-radius: 6px;
      
    }
    .list-box-left {
      margin-right: 6px;
      img {
        width: 64px;
        height: 64px;
        border-radius: 5px;
        object-fit:cover
      }
    }

    .list-box-right {
      width: calc(100% - 70px);
      .content {
        display: flex;
      }
      .left-amount {
        display: inline-block;
        padding: 2px 3px 1px;
        height: 17px;
        font-size: 12px;
        color: #F9591B;
        line-height: 17px;
        margin: 6px 0;
        background: rgba(249, 89, 27, 0.09);
        border-radius: 3px;
      }
      .right-amount{
          display: inline-block;
          padding: 2px 3px 1px;
          box-sizing: border-box;
          background: rgba(220,160,60,0.15);
            border-radius: 3px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #AE6C28;
      }
      .discounts {
          margin-top: 8px;
        display: flex;
        flex-wrap: wrap;
        position: relative;
        .discount {
          position: relative;
          padding: 2px 4px 1px;
          margin: 0 6px 5px 0;
          height: 17px;
          font-size: 12px;
          color: #F9591B;
          line-height: 17px;
          border-radius: 3px;
          // border: 1px solid #F9591B;
          &::before {
            content: "";
            position: absolute;
            left: 0;
            width: 200%;
            height: 200%;
            border: 1px solid #F9591B;
            border-radius: 6px; /* 也可以设置圆角 */
            transform-origin: 0 -4px;
            transform: scale(0.5, 0.5);
            box-sizing: border-box;
          }
        }
        .foldimg{
            position: absolute;
            right: 0px;
            top:6px;
            width: 10px;
            height: 8px;
        }
      }
    }

    .left {
      flex: 1;
      padding-right: 15px;
      .title {
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
        .t-left {
          font-size: 16px;
          color: #333333;
          line-height: 22px;
          font-weight: bold;
        }
        .t-right {
        //   font-size: 16px;
        //   color: #666666;
          // padding-right: 15px;
          font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
        }
      }
      .addres {
        font-size: 14px;
        color: #666666;
        line-height: 20px;
      }

    }
    .right {
      width: 27px;
      height: 52px;
      border-left: 1px solid #eeeeee;
      position: relative;
      img {
        // width: 12px;
        // height: 17px;
        width: 16px;
        height: 18px;
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
      }
    }
  }
  .van-swipe__indicator {
    height: 4px;
    opacity: 0.8;
    background-color: #DDDDDD;
  }
  .van-swipe__indicator--active {
    background-color: #ffffff;
    width: 12px;
    border-radius: 4px;
  }

  // .van-popup {
  //   width: 100%;
  // }
  // .popImg {
  //   width: 100%;
  // }
  .imgPopup {
    overflow-y: auto;
    width: 100%;
    position: fixed;
    top:0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 1000;
    .left {
      width: 100%;
    }
    .close,.right {
      position: fixed;
      width: 20px;
      height: 20px;
      top: 20px;
      right: 20px;
    }
    .close::before,
    .close::after {
      position: absolute;
      content: ' ';
      background-color: #fff;
      left: 20px;
      width: 2px;
      height: 20px;
    }
    .close::before {
      transform: rotate(45deg);
    }
    .close::after {
      transform: rotate(-45deg);
    }
  }

  // .van-pull-refresh {
  //   overflow-y: auto;
  // }
    .turn{
      // width:100px;
      // height: 100px;
      // background: aqua;
      animation:turn 1s linear infinite;      
      // margin: 100px auto;
    }
    /* 
      turn : 定义的动画名称
      1s : 动画时间
      linear : 动画以何种运行轨迹完成一个周期
      infinite :规定动画应该无限次播放
     */
    @keyframes turn{
      0%{-webkit-transform:rotate(0deg);}
      25%{-webkit-transform:rotate(90deg);}
      50%{-webkit-transform:rotate(180deg);}
      75%{-webkit-transform:rotate(270deg);}
      100%{-webkit-transform:rotate(360deg);}
    }
}
</style>
